export const ON_URL_CHANGE = "[ROUTER] ON_URL_CHANGE";